<template>
    <span class="bid-steps-tooltip" :class="{ 'has-error': hasError }">
        <i class="fas fa-info-circle"></i>
        <span class="bid-steps">
            <p>
                {{ $t('bidding_steps_info') }}
            </p>
            <ul>
                <li v-for="step in bidSteps.pretty" :key="step.start">
                    <span class="step-start">
                        <small v-if="!step.end">&gt;</small>
                        {{ currencyFormater(step.start, currency) }}
                    </span>
                    <span v-if="!!step.end"> - </span>
                    <span v-else>&nbsp;</span>
                    <span v-if="!!step.end" class="step-end">
                        {{ currencyFormater(step.end, currency) }}
                    </span>
                    <span v-else class="step-end">&nbsp;</span>
                    <span> : </span>
                    <span class="step-size">
                        {{ currencyFormater(step.step, currency) }}
                        {{ $t('bidding_steps_steps') }}
                    </span>
                </li>
            </ul>
        </span>
    </span>
</template>

<script>
export default {
    name: 'BidSteps',
    props: {
        bidSteps: {
            type: Object,
            required: true,
        },
        currency: {
            type: String,
            required: true,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
.has-error {
    i {
        color: $error-color;
    }
}
.bid-steps-tooltip {
    position: absolute;
    z-index: 5;
    padding: 4px;
    top: 3px;
    color: $grey-bg-dark;

    &:hover {
        .bid-steps {
            display: block;
        }
    }
}
.bid-steps {
    display: none;
    position: absolute;
    z-index: 6;
    background-color: white;
    box-shadow: 0 0 4px 0 $grey-bg-dark;
    padding: 5px;
    color: black;
    bottom: 30px;
    right: -32px;
    width: 280px;
    
    :after {
        content: '';
        position: absolute;
        top: calc(100% - 10px);
        right: 0px;
        width: 100px;
        height: 20px;
        background-color: transparent;
    }

    p,
    li {
        font-size: 12px;
        margin: 0;
    }

    ul {
        padding-left: 0;

        li {
            list-style: none;
            display: inline-flex;
            width: 100%;
            font-size: 10px;
            line-height: 10px;
            margin: 0;
            padding: 2px;

            &:nth-child(2n) {
                background-color: $grey-bg-lightest;
            }

            span {
                padding: 0 4px;
                text-align: center;
                min-width: 12px;
            }

            .step-start {
                padding-left: 0;
                width: 84px;
                text-align: left;
            }
            .step-end {
                width: 64px;
                text-align: left;
            }
            .step-size {
                width: 100px;
                text-align: left;
            }
        }
    }
}
</style>
